import {useEffect, useState} from "react";
import axios from "axios";
import {config, service} from ".";
import { PAGE_ID } from "./config";
import {
  setItemBySession,
  itemType
} from 'MMT-UI/storages/client/sessionStorage';
import { STORAGE_CONSTANTS } from "../../../constants/TrainConstants";
import { useDispatch } from "react-redux";
import { USER_UPDATE_IRCTC_ID } from "../../../constants/ActionTypes";
import { generateId } from '../../../utils/trainUtils';

const cache = {};

const useFetchData = (pageId) => {
  const [state, setState] = useState({
    response: {},
    status: config.STATUS.IP
  });
  const dispatch = useDispatch();

  useEffect(() => {
    const traceId = generateId();
    const headers = {"X-Trace-Id": traceId};
    const {url, payload} = service.constructUrl(pageId, "GET");
    function callAPI() {
      axios.post(url, payload,{ headers })
        .then(res => {
          if (res.data.error) {
            throw(res.data);
          }
          cache[pageId] = res.data;
          setState({
            response: res.data,
            status: config.STATUS.D
          });
          if (pageId === PAGE_ID.BOOKING_DETAILS) {
            dispatch({
              type: USER_UPDATE_IRCTC_ID,
              payload: res?.data?.irctcUserId,
            })
            setItemBySession(
              STORAGE_CONSTANTS.VERIFIED_USER_ID,
              res?.data?.irctcUserId,
              { isPiiData: true, shouldStringifyJson: true },
              itemType.ES
            );
          }
        })
        .catch(err => {
          setState({
            response: {
              message: err.message,
            },
            status: config.STATUS.F
          });
        })
    }
    if (cache[pageId]) {
      setState({
        response: cache[pageId],
        status: config.STATUS.D,
      });
  } else {
    callAPI();
    }
  }, []);

  const { response, status } = state;

  return {
    response,
    status,
  }
}

export default useFetchData;
